import { Helmet } from "react-helmet";
import AboutUs from "./AboutUs";
import FullAboutUs from "./FullAboutUs";
import Intro from "./Intro";
import OutroText from "./OutroText";
import Services from "./Services";
const Home = () => {
  return (
    <>
      <Helmet>
        <title>Durrat Al Bahr</title>
      </Helmet>
      <div className="home-page-wrapper">
        <Intro />
        <AboutUs />
        <FullAboutUs />
        <Services />
        <OutroText />
      </div>
    </>
  );
};

export default Home;
